import { Injectable } from '@angular/core';
import { ToastrService as NgxToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastrService {
  constructor(private toastr: NgxToastrService) {}

  success(message: string, title?: string) {
    this.toastr.success(message, title || 'Success');
  }

  error(message: string, title?: string) {
    this.toastr.error(message, title || 'Error');
  }

  info(message: string, title?: string) {
    this.toastr.info(message, title || 'Info');
  }

  warning(message: string, title?: string) {
    this.toastr.warning(message, title || 'Warning');
  }
}
